import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dictionary } from 'lodash';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { NavTitle } from '../models/nav.title';

@Injectable({
    providedIn: 'root'
})
export class NavService {

    private navTitleList: NavTitle[] = [];

    public navVisibility$: Subject<boolean> = new Subject<boolean>();

    public isFromMobileApp = false;

    constructor(
        private httpClient: HttpClient
    ) {
    }

    public getNavTitleItemByKey(key: string): NavTitle {
        const index = this.navTitleList.findIndex(x => x.key === key);

        if (index >= 0) {
            return this.navTitleList[index];
        }

        return new NavTitle();
    }

    public getCompanyMessage(messageCodes: string[]): Observable<Dictionary<string>> {
        return this.httpClient.post<Dictionary<string>>(`${environment.corepfmapi}/company/CompanyCustomMessage`, messageCodes)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(error);
                }),
                shareReplay(1)
            );
    }

    public setVisibility(source: string): void {
        this.isFromMobileApp = source?.toLowerCase() === 'mobile';
        this.navVisibility$.next(this.isFromMobileApp);
    }
}
